exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".quantity,\n.unit {\n  width: 150px;\n}\n.unit {\n  margin-left: 16px;\n}\n.quantity {\n  padding-left: 24px;\n}\n#notes {\n  border-radius: 16px;\n}\n[for='post-body'] {\n  margin-bottom: 8px;\n}\n.ending {\n  margin-left: 24px;\n}\nh1 {\n  margin: 0;\n  padding: 0;\n  padding: 16px 0;\n}\nlabel {\n  margin-bottom: 8px;\n}\nlabel.invalid {\n  color: red;\n}\n\n/deep/ .page-header {\n  align-items: center;\n  height: 82px;\n}\n", ""]);

// exports
